import autosize from "autosize";

export default {
    data() {
        return {
            active: null
        };
    },
    render() {
        return this.$scopedSlots.default();
    },
    mounted() {
        autosize(this.$el.querySelector(".autosizeable"));
    }
};
